import React from 'react'
import { useViewport, viewportBreakpoint, MobileViewportProvider } from '../../../utils'
import { Metas, CardInfoMobile } from '.'
import { ChevronDown, ChevronUp } from 'react-feather'
import { ButtonBookmarkIcon } from '../../../components'

const Avatar = ({image, bookmark}) => {
  const { width } = useViewport()
  const breakpoint = viewportBreakpoint.tablet
  const isMobile = width < breakpoint
  const size = isMobile ? '78px' : bookmark ? '110px' : '150px'

  return (
    <div
      style={{minWidth: size, height: size}}
      className="mr-4 lg:mr-8 flex justify-center items-center"
    >
      <div
        className="w-full h-full bg-center bg-auto bg-no-repeat rounded rounded-full"
        style={{
          backgroundColor: '#f9f9f9',
          backgroundImage: `url('/images/logos/${image}')`,
          backgroundBlendMode: 'multiply',
          backgroundSize: '60%'
        }}
      />
      {/* <img src={`/images/logos/${image}`} alt="logo" style={{backgroundBlendMode: 'multiply'}}/> */}
    </div>
  )
}

const Card = ({embed, data, bookmark}) => {
  const { name, image } = data
  const [isOpen, setIsOpen] = React.useState(false)

  const handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setIsOpen(!isOpen)
  }

  return (
    <div
      className={`rounded p-4 lg:p-8 relative ${embed ? 'bg-white' : ''} h-full`}
      style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
    >
      <div className="flex">
        <Avatar image={image} bookmark={bookmark}/>
        <div className="w-full">
          <div className="flex justify-between">
            <h3 className={`font-bold lg:text-2xl font-primary ${bookmark ? 'mb-5' : 'mb-3'} leading-tight`}>
              {name}
            </h3>
            {
              bookmark &&
              <ButtonBookmarkIcon />
            }
          </div>

          <Metas data={data}/>
          <MobileViewportProvider>
            <CardInfoMobile data={data} isOpen={isOpen}/>
          </MobileViewportProvider>
        </div>
      </div>

      <div className="md:hidden">
        {
          !isOpen &&
          <div className="w-full flex justify-center items-center" onClick={handleToggle}>
            <ChevronDown width={14} className/>
          </div>
        }
        {
          isOpen &&
          <div className="w-full flex justify-center items-center" onClick={handleToggle}>
            <ChevronUp width={14}/>
          </div>
        }
      </div>
    </div>
  )
}

export { Card }
